import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useMemo } from 'react';
import { propStr } from '../../../../helpers/custom-prop-types';
import ColumnContentDocumentOne from './ColumnContentDocumentOne';
const ColumnContentDocument = (props) => {
    const { idList } = props;
    const mapIds = useMemo(() => {
        let values = [];
        if (_.isString(idList)) {
            values = idList.split(',');
        }
        if (_.isArray(idList)) {
            values = idList;
        }
        return _.uniq(values.filter((v) => (v || '').length));
    }, [idList]);
    return (_jsx("div", Object.assign({ className: 'custom_document' }, { children: mapIds.map((id) => (_jsx(ColumnContentDocumentOne, { id: id }, id))) })));
};
ColumnContentDocument.propTypes = {
    idList: propStr().isRequired,
};
export default ColumnContentDocument;
